import React, { Component } from 'react';
import { SearchIcon, ChevronDownIcon } from '../shared/icons';
import styles from './index.module.scss';

const FILTER_CONFIG = [
  { label: 'From Location',       key: 'fromLocation',      type: 'text'   },
  { label: 'To Location',         key: 'toLocation',        type: 'text'   },
  { label: 'Shipping Liner ID',   key: 'linerId',           type: 'number' },
  { label: 'Service Provider ID', key: 'serviceProviderId', type: 'text'   },
  { label: 'Booking No',          key: 'bookingNo',         type: 'text'   },
];

class BookingFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rfqNumber: '',
      fromLocation: '',
      toLocation: '',
      linerId: '',
      serviceProviderId: '',
      bookingNo: '',
      openKey: null,
    };
    this._debounceTimer = null;
    this._inputRefs = {};
  }

  componentWillUnmount() {
    clearTimeout(this._debounceTimer);
  }

  _triggerFilterChange = () => {
    const { onFilterChange } = this.props;
    if (!onFilterChange) return;
    const { rfqNumber, fromLocation, toLocation, linerId, serviceProviderId, bookingNo } = this.state;
    const params = {};
    if (rfqNumber)       params.rfqNumber       = rfqNumber;
    if (fromLocation)    params.fromLocation    = fromLocation;
    if (toLocation)      params.toLocation      = toLocation;
    if (linerId)         params.linerId         = Number(linerId);
    if (serviceProviderId) params.serviceProviderId = serviceProviderId;
    if (bookingNo)       params.bookingNo       = bookingNo;
    onFilterChange(params);
  };

  _scheduleCall = () => {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(this._triggerFilterChange, 500);
  };

  handleSearchChange = (value) => {
    this.setState({ rfqNumber: value }, this._scheduleCall);
  };

  handleFilterChange = (key, value) => {
    this.setState({ [key]: value }, this._scheduleCall);
  };

  toggleDropdown = (key) => {
    this.setState(prev => {
      const next = prev.openKey === key ? null : key;
      if (next) {
        setTimeout(() => {
          const ref = this._inputRefs[key];
          if (ref) ref.focus();
        }, 30);
      }
      return { openKey: next };
    });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Escape') {
      this.setState({ openKey: null });
    }
  };

  hasActiveFilters = () => {
    const { rfqNumber, fromLocation, toLocation, linerId, serviceProviderId, bookingNo } = this.state;
    return !!(rfqNumber || fromLocation || toLocation || linerId || serviceProviderId || bookingNo);
  };

  clearFilters = () => {
    clearTimeout(this._debounceTimer);
    this.setState(
      { rfqNumber: '', fromLocation: '', toLocation: '', linerId: '', serviceProviderId: '', bookingNo: '', openKey: null },
      () => {
        const { onFilterChange } = this.props;
        if (onFilterChange) onFilterChange({});
      }
    );
  };

  getDisplayLabel = (config) => {
    const val = this.state[config.key];
    if (val) return `${config.label}: ${val}`;
    return config.label;
  };

  render() {
    const { rfqNumber, openKey } = this.state;

    return (
      <div className={styles.filterRow}>
        {/* Search box → rfqNumber */}
        <div className={styles.searchBox}>
          <SearchIcon />
          <input
            type="text"
            placeholder="Search by RFQ number..."
            value={rfqNumber}
            onChange={e => this.handleSearchChange(e.target.value)}
          />
        </div>

        {/* Filter chips */}
        {FILTER_CONFIG.map(config => {
          const val = this.state[config.key];
          const isOpen = openKey === config.key;
          const hasValue = Boolean(val);

          return (
            <div
              key={config.key}
              className={styles.dropdown}
              style={{ position: 'relative', cursor: 'pointer', borderColor: hasValue ? '#1452c8' : undefined }}
              onClick={() => this.toggleDropdown(config.key)}
            >
              {isOpen ? (
                <input
                  ref={r => { this._inputRefs[config.key] = r; }}
                  type={config.type}
                  placeholder={config.label}
                  value={val}
                  className={styles.filterInput}
                  onClick={e => e.stopPropagation()}
                  onChange={e => this.handleFilterChange(config.key, e.target.value)}
                  onKeyDown={this.handleKeyDown}
                  style={{
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    fontSize: '13px',
                    width: '120px',
                    color: '#1a2340',
                  }}
                />
              ) : (
                <span style={{ color: hasValue ? '#1452c8' : undefined }}>
                  {this.getDisplayLabel(config)}
                </span>
              )}
              <span className={styles.chevron}><ChevronDownIcon /></span>
            </div>
          );
        })}

        {this.hasActiveFilters() && (
          <button className={styles.btnClearFilter} onClick={this.clearFilters}>
            ✕ Clear Filter
          </button>
        )}
      </div>
    );
  }
}

export default BookingFilters;
